import { Injectable } from "@angular/core";
import { Functions, httpsCallable } from "@angular/fire/functions";
import {
  createFunctionResult,
  FUNCTION_RESULT_STATUS,
  FunctionResult,
} from "@nova/common-interfaces";
import { FUNCTION_NAME } from "@rfm/shared-interfaces";

import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ThirdPartyUispService {
  private _isLoading = new BehaviorSubject<boolean>(false);
  isLoading$: Observable<boolean> = this._isLoading.asObservable();

  constructor(protected functions: Functions) {}

  updateDeviceName(id: string, name: string) {
    this._isLoading.next(true);

    return new Promise<FunctionResult<boolean>>(
      (resolve, reject) => {
        const callable = httpsCallable<
          any,
          FunctionResult<boolean>
        >(
          this.functions,
          FUNCTION_NAME.THIRDPARTY_UISP_UPDATE_DEVICE_NAME
        );
        callable({ device_id: id, name: name })
          .then(
            (result) => {
              resolve(
                createFunctionResult<boolean>(
                  FUNCTION_RESULT_STATUS.SUCCESS,
                  result.data.data
                )
              );
            },
            (error) => {
              console.error(error);
              reject(
                createFunctionResult<boolean>(
                  FUNCTION_RESULT_STATUS.ERROR,
                  undefined
                )
              );
            }
          )
          .finally(() => {
            this._isLoading.next(false);
          });
      }
    );
  }
  activateDevice(id: string) {
    this._isLoading.next(true);

    return new Promise<FunctionResult<boolean>>(
      (resolve, reject) => {
        const callable = httpsCallable<
          any,
          FunctionResult<boolean>
        >(
          this.functions,
          FUNCTION_NAME.THIRDPARTY_UISP_ACTIVATE_DEVICE
        );
        callable(id)
          .then(
            (result) => {
              resolve(
                createFunctionResult<boolean>(
                  FUNCTION_RESULT_STATUS.SUCCESS,
                  result.data.data
                )
              );
            },
            (error) => {
              console.error(error);
              reject(
                createFunctionResult<boolean>(
                  FUNCTION_RESULT_STATUS.ERROR,
                  undefined
                )
              );
            }
          )
          .finally(() => {
            this._isLoading.next(false);
          });
      }
    );
  }
  suspendDevice(id: string) {
    this._isLoading.next(true);

    return new Promise<FunctionResult<boolean>>(
      (resolve, reject) => {
        const callable = httpsCallable<
          any,
          FunctionResult<boolean>
        >(
          this.functions,
          FUNCTION_NAME.THIRDPARTY_UISP_SUSPEND_DEVICE
        );
        callable(id)
          .then(
            (result) => {
              resolve(
                createFunctionResult<boolean>(
                  FUNCTION_RESULT_STATUS.SUCCESS,
                  result.data.data
                )
              );
            },
            (error) => {
              console.error(error);
              reject(
                createFunctionResult<boolean>(
                  FUNCTION_RESULT_STATUS.ERROR,
                  undefined
                )
              );
            }
          )
          .finally(() => {
            this._isLoading.next(false);
          });
      }
    );
  }
}
